import { FC } from "react"
import { cn } from "@bem-react/classname"
import { Cryptocurrency } from "@/components/UI/Cryptocurrency"
import { Wallet } from '@/core/services/Wallets/WalletInterface'

import './Cryptocurrencies.scss'

const cnCryptocurrencies = cn('Cryptocurrencies')

interface CryptocurrencyProps {
	className?: string
	currency: 'USD' | 'EUR'
	data: Wallet[]
}

export const Cryptocurrencies: FC<CryptocurrencyProps> = ({
	className,
	currency,
	data
}: CryptocurrencyProps): JSX.Element => {
	
	return (
		<div className={cnCryptocurrencies(null, [className])}>
			{data.map((wallet, i) => (
				<Cryptocurrency
					className={cnCryptocurrencies('cryptocurrency')}
					isHome
					key={i}
					wallet={wallet}
					currency={currency}
					up={wallet?.change?.includes('+') || !wallet?.change?.includes('-')}
				/>
			))}
		</div>
	)
}